<page-headline
    [linkTitle]="'Incentives Home'"
    [module]="'incentives'"
    [moduleIcon]="'fa-dollar-sign'"
    [moduleLink]="'incentives'"
    [pageTitle]="'Incentives Upgrade'"
>
</page-headline>
<module-upgrade
    [headline]="headline"
    [shortOverview]="shortOverview"
    [selligPointHeader]="selligPointHeader"
    [logoPlaceholder]="logoPlaceholder"
    [moduleShortDescription]="moduleShortDescription"
    [backgroundColor]="backgroundColor"
    [showCompensafelink]="true"
>
</module-upgrade>
